module.exports = {"goToMessageCenterUrl":"/smc/customer","viewYourAccountUrl":"/myaccount/home","visitTheHelpCenterUrl":"/selfhelp/home"}


// WEBPACK FOOTER //
// ../data/emailFormURL.json